<template>
    <v-container id="importarpagofacil-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>IMPORTAR ARCHIVO DE PAGO FÁCIL</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="filtros.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-select
                    v-model="filtros.mes"
                    :items="listameses"
                    label="Mes"
                    item-text="mes"
                    item-value="nromes"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="5" lg="5">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="Listar"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Nueva Importación"
                    @click="Nuevo"
                  >
                    <v-icon dark> mdi-new-box </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idimportacion"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width full-height>
        <v-container
            fluid
            class="full-height"
            style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialognuevo" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Importacion de Archivo Págo Fácil
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="Grabar">
                  Grabar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialognuevo = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row row wrap>
              <v-col cols="12">
                <v-menu
                  v-model="menufechaarchivo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfechaarchivo"
                      label="Fecha Archivo"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="edited.fechaarchivo"
                    @input="menufechaarchivo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-textarea
                  name="input-5-2"
                  label="Observaciones"
                  v-model="edited.observacion"
                  rows="2"
                  row-height="15"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="8" lg="8">
                <v-file-input
                  v-model="files"
                  color="deep-purple accent-4"
                  counter
                  label="Seleccione el Archivo de Pago Fácil a Procesar"
                  multiple
                  placeholder="Seleccione Archivos"
                  prepend-icon="mdi-paperclip"
                  :show-size="1000"
                  height="20px"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                    >
                      {{ text }}
                    </v-chip>
                    <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                      +{{ files.length - 2 }} Archivo(s)
                    </span>
                  </template>
                </v-file-input>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="alineacentro">
                <v-btn :disabled="files.length===0" color="blue darken-1" text @click="VisualizarDatos">
                  Visualizar Datos
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap v-if="verdatosarchivo">
              <v-col cols="12">
                <card class="DatosMatriculado">
                  <v-card-title>
                    <v-row class="text-center">
                      <v-col cols="12">
                        <v-card
                            dark
                            color="info"
                            class="alineacentro DatosMatriculado"
                        >
                            <strong>DATOS DEL ARCHIVO</strong>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text>
                    <v-row dense>
                      <v-col>
                        <v-spacer />
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12" md="4" lg="4">
                        <p class="TituloGrilla"> Fecha Creación Archivo: {{ fechadmy(fechacreacionarchivo) }} </p>
                      </v-col>
                      <v-col cols="12" md="8" lg="8">
                        <p class="TituloGrilla"> Cant. Lotes: {{ totallotesarchivo }} -- Cant. Transacciones: {{ totaltransarchivo }}</p>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-data-table
                            :headers="columnasarchivo"
                            :items="listaarchivo"
                            :items-per-page="10"
                            :footer-props="{
                                'items-per-page-text': 'Filas por Página:',
                                'items-per-page-all-text': 'Todos',
                            }"
                            item-key="idimportacion"
                            class="elevation-1"
                            dense
                            no-data-text="Sin Registros"
                            multi-sort
                        >
                          <template v-slot:item.estado="{ item }">
                            <v-chip :color="getcolor(item.estado)" dark>
                                {{ item.estado }}
                            </v-chip>
                          </template>
                          <template v-slot:item.importefactura="{ item }">
                            <v-chip color="seagreen" dark>
                                {{ item.importefactura }}
                            </v-chip>
                          </template>
                          <template v-slot:item.importedeberiacobrar="{ item }">
                            <v-chip color="orange" dark>
                                {{ item.importedeberiacobrar }}
                            </v-chip>
                          </template>
                          <template v-slot:item.importecobrado="{ item }">
                            <v-chip color="blue" dark>
                                {{ item.importecobrado }}
                            </v-chip>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "importarpagofacil",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 9,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      columnas: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idarchivo",
          width: 70,
        },
        {
          text: "F. Carga",
          align: "center",
          sortable: true,
          value: "fechacarga",
          width: 130,
        },
        {
          text: "F. Archivo",
          align: "center",
          sortable: true,
          value: "fechaarchivo",
          width: 120,
        },
        {
          text: "Archivo",
          align: "center",
          sortable: true,
          value: "archivo",
          width: 100,
        },
        {
          text: "Usu. Carga",
          align: "center",
          sortable: true,
          value: "usuario",
          width: 120,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 120,
        },
        /* {
          text: "Obs.",
          align: "center",
          sortable: true,
          value: "observacion",
          width: 120,
        }, */
        {
          text: "Lotes OK",
          align: "center",
          sortable: true,
          value: "cantidadlotescorrectos",
          width: 120,
        },
        {
          text: "Lotes Error",
          align: "center",
          sortable: true,
          value: "cantidadlotesconerror",
          width: 120,
        },
        {
          text: "Det OK",
          align: "center",
          sortable: true,
          value: "cantidaddetallescorrectos",
          width: 120,
        },
        {
          text: "Det Error",
          align: "center",
          sortable: true,
          value: "cantidaddetallesconerror",
          width: 120,
        }
      ],
      lista: [],
      filtros: {
        anio: 0,
        mes: 0
      },
      listaanios: [],
      listameses: [
        {nromes: 1, mes: 'Enero'},
        {nromes: 2, mes: 'Febrero'},
        {nromes: 3, mes: 'Marzo'},
        {nromes: 4, mes: 'Abril'},
        {nromes: 5, mes: 'Mayo'},
        {nromes: 6, mes: 'Junio'},
        {nromes: 7, mes: 'Julio'},
        {nromes: 8, mes: 'Agosto'},
        {nromes: 9, mes: 'Septiembre'},
        {nromes: 10, mes: 'Octubre'},
        {nromes: 11, mes: 'Noviembre'},
        {nromes: 12, mes: 'Diciembre'}
      ],
      dialognuevo: false,
      files: [],
      ReglaRequerido: [
        v => !!v || 'Requerido'
      ],
      menufechaarchivo: false,
      edited: {
        idarchivo: 0,
        fechaarchivo: '',
        archivo: [],
        observacion: '',
        usuario: ''
      },
      listaarchivo: [],
      columnasarchivo: [
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 100,
        },
        {
          text: "Imp Fac",
          align: "center",
          sortable: true,
          value: "importefactura",
          width: 120,
        },
        {
          text: "Imp a Cobrar",
          align: "center",
          sortable: true,
          value: "importedeberiacobrar",
          width: 150,
        },
        {
          text: "Cobrado",
          align: "center",
          sortable: true,
          value: "importecobrado",
          width: 110,
        },
        {
          text: "Lote",
          align: "center",
          sortable: true,
          value: "nrolote",
          width: 80,
        },
        {
          text: "Trans",
          align: "center",
          sortable: true,
          value: "codigotransaccion",
          width: 90,
        },
        {
          text: "Factura",
          align: "center",
          sortable: true,
          value: "idfactura",
          width: 110,
        },
        {
          text: "F. Fac",
          align: "center",
          sortable: true,
          value: "fechafactura",
          width: 120,
        },

        {
          text: "F. Cobro",
          align: "center",
          sortable: true,
          value: "fechahorapagotransaccion",
          width: 130,
        },
        {
          text: "Alumno",
          align: "center",
          sortable: true,
          value: "alumno",
          width: 180,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "conceptofactura",
          width: 130,
        },
        /*{
          text: "Cuota",
          align: "center",
          sortable: true,
          value: "cuotafactura",
          width: 110,
        },*/
        {
          text: "Term Cobro",
          align: "center",
          sortable: true,
          value: "terminalcobro",
          width: 130,
        }
      ],
      fechacreacionarchivo: '',
      totallotesarchivo: 0,
      totaltransarchivo: 0,
      verdatosarchivo: false
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        this.filtros.anio= (new Date()).getFullYear();
        this.filtros.mes= (new Date()).getMonth()+1;
        var i=0;
        var anioactual= (new Date()).getFullYear();
        for(i=2023;i<=anioactual+1;i++){
          this.listaanios.push({anio: i});
        }
        this.Listar();
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    Listar () {
      this.loading=true;
      var param= JSON.stringify({anio: parseInt(this.filtros.anio), mes: parseInt(this.filtros.mes) });
      axios.post("contable/PostImportacionArchivoPF", param, { headers: {"Content-Type": "application/json", }})
        .then((result) => {
          if(result.data.resultado===0){
            this.lista = result.data.datos;
            this.loading=false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
      })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    Nuevo () {
      this.verdatosarchivo=false;
      this.edited= {
        idarchivo: 0,
        fechaarchivo: this.fechaFormatoYMD(new Date()),
        archivo: [],
        observacion: '',
        usuario: this.usuario
      }
      this.dialognuevo=true;
    },
    fechaFormatoYMD(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    Grabar () {
      let files = new FormData();
      let file = this.files[0];
      files.append('files', file, file.name);
      axios.post("contable/PostArchivosPagoFacil", files, {
        headers: {
          "content-type": "multipart/form-data",
        }
      }).then((result) => {
        if (result.data.resultado === 0) {
          this.GuardarImportacion(result.data.archivos);
        } else {
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    GuardarImportacion (archivos) {
      if (archivos != null) {
        this.edited.archivo=[];
        var reg = archivos[0];
        this.edited.archivo.push({nombrearchivo: reg.nombrearchivo, urlarchivo: reg.url });
        /*for (var i = 0; i < archivos.length; i++) {
        }*/
      }
      const impPF = JSON.stringify(this.edited);
      axios.post("contable/PostGuardaImportacionArchivoPF", impPF, { headers: { "Content-Type": "application/json" } })
        .then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevo = false;
            this.Listar();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    VisualizarDatos () {
      this.loading = true;
      let files = new FormData();
      let file = this.files[0];
      files.append('files', file, file.name);
      axios.post("contable/PostVerArchivoPagoFacil", files, {
        headers: {
          "content-type": "multipart/form-data",
        }
      }).then((result) => {
        if (result.data[0] === 0) {
          this.listaarchivo= result.data[3];
          this.fechacreacionarchivo= result.data[2].fechacreacionarchivo;
          this.totallotesarchivo= result.data[2].totallotesarchivo;
          this.totaltransarchivo= result.data[2].totaltransarchivo;
          this.verdatosarchivo=true;
          this.loading = false;
        } else {
          this.verdatosarchivo=false;
          this.loading = false;
          this.MostrarMensaje('Error', result.data[1], false);
        }
      }).catch((error) => {
        this.verdatosarchivo=false;
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    fechadmy: function (fechaaconvertir) {
      if (fechaaconvertir != null && fechaaconvertir != "") {
        var fecha = new Date(fechaaconvertir);
        fecha.setDate(fecha.getDate());
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    getcolor(estado) {
      if (estado === 'ABONADA') {return "green";}
      else if (estado === 'DIFERENCIA') {return "red";}
      else if (estado === 'FACTURA NO ENCONTRADA') {return "black";}
    },
},
  computed: {
    fechalocalfechaarchivo: function () {
      if (this.edited.fechaarchivo != null && this.edited.fechaarchivo != "") {
        var fecha = new Date(this.edited.fechaarchivo);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.fullpantalla{
    height: 100% !important;
    width: 100% !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>